import { render, staticRenderFns } from "./rightbox.vue?vue&type=template&id=2952182d&scoped=true&"
import script from "./rightbox.vue?vue&type=script&lang=js&"
export * from "./rightbox.vue?vue&type=script&lang=js&"
import style0 from "./rightbox.vue?vue&type=style&index=0&id=2952182d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952182d",
  null
  
)

export default component.exports